module.exports = __webpack_public_path__ + "static/media/postman.63bc9e1a.svg";